import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Cover extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      title: null,
      subtitle: null,
      supratitle: null,
      video: null,
      mobile: null,
      but: null,
      but2: null,
      clock: null,
      durable: null,
      num: []
    }

  }

  mount() {


  // const endTime = new Date(2023, 9, 5, 15, 0, 0).getTime();

  // // store clock div to avoid repeatedly querying the DOM
  // const clock = this.ref.clock

  // // calculate remaining time from now until deadline
  // function getRemainingTime(deadline) {
  //   const currentTime = new Date().getTime();
  //   return deadline - currentTime;
  // }

  // // pad value with zero
  // function pad(value) {
  //   return ('0' + Math.floor(value)).slice(-2);
  // }

  // // show time repeatedly
  // function showTime() {
  //   const remainingTime = getRemainingTime(endTime);
  //   const seconds = pad((remainingTime / 1000) % 60);
  //   const minutes = pad((remainingTime / (60 * 1000)) % 60);
  //   const hours = pad((remainingTime / (60 * 60 * 1000)) % 24);
  //   const days = pad(remainingTime / (24 * 60 * 60 * 1000));

   

  //   if(clock){
  //     clock.innerHTML = `${days}<span>days</span> ${hours}:${minutes}:${seconds}`;
  //   }
    

  //   // ensure clock only updates if a second or more is remaining
  //   if (remainingTime >= 1000 && clock) {
  //     requestAnimationFrame(showTime);
  //   }
  // }

  // kick it all off
  //requestAnimationFrame(showTime);







    this.title = new SplitText(this.ref.title, {
        type: "words",
        wordsClass: 'word'
    })
     this.subtitle = new SplitText(this.ref.subtitle, {
         type: "words",
         wordsClass: 'word'
     })
    this.title.words.forEach((item, i) => {
       // item.dataset.content = item.innerText
        item.style = `--word-index: ${i}`
    })

    this.subtitle.words.forEach((item, i) => {
       // item.dataset.content = item.innerText
        item.style = `--word-index: ${i  + this.title.words.length}`
    })

    $(this.ref.title).addClass('visible')
    $(this.ref.subtitle).addClass('visible')
    $(this.ref.but).addClass('visible')
    $(this.ref.but2).addClass('visible')
    $(this.ref.clock).addClass('visible')
     $(this.ref.supratitle).addClass('visible')

     this.ref.num.forEach((item, i)=>{
      $(item).addClass('visible')
     })

    // this.ref.inview.forEach((item, i) => {

    // let mm = gsap.matchMedia();
      //mm.add("(min-width: 768px)", () => {

      if (this.ref.video) {

        ScrollTrigger.create({
          trigger: this.element,
          start: "top bottom",
          end: "bottom  top",
          onEnter: ({progress, direction, isActive}) => {
            this.ref.video.paused && this.ref.video.play()
          // console.log('enter')
          },
          onLeave: ({progress, direction, isActive}) => {
            !this.ref.video.paused && this.ref.video.pause()
        //    console.log(this.ref.video.paused)
          },
          onEnterBack: ({progress, direction, isActive}) => {
            this.ref.video.paused && this.ref.video.play()
       //    console.log('back')
          },
          onLeaveBack: ({progress, direction, isActive}) => {
            !this.ref.video.paused && this.ref.video.pause()
        //    console.log('leaveback')
          }
        });
      }
    //  });

    if(this.ref.durable) {
      gsap.to(this.ref.durable,{
        yPercent: 50, 
        scrollTrigger: {
          trigger: this.element,
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      })
    }

     


    //   ScrollTrigger.create({
    //     trigger: "html",
    //     start: "top top+=100",
    //     onUpdate: self => {

    //       this.body.toggleClass('hasmenu', self.direction < 0 || stage.scrolltop < stage.h / 4)
    //     }
    //   });
   
}

  unmount() {




  }


}

module.exports = Cover
